var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26753 4.6745C6.80158 3.84919 6.56861 3.43654 6.70534 3.06138C6.84207 2.68623 7.28227 2.53029 8.16267 2.2184L8.91233 1.95284C9.45092 1.76203 9.72025 1.66663 9.99984 1.66663C10.2794 1.66663 10.5488 1.76203 11.0873 1.95284L11.837 2.2184C12.7174 2.53029 13.1576 2.68623 13.2943 3.06138C13.4311 3.43654 13.1981 3.84919 12.7322 4.6745L12.302 5.43633C12.0814 5.82709 11.9711 6.02247 11.7781 6.17568C11.585 6.3289 11.4061 6.38008 11.0483 6.48242C10.7054 6.58045 10.3146 6.66663 9.99984 6.66663C9.68509 6.66663 9.29425 6.58045 8.95142 6.48242C8.59359 6.38008 8.41467 6.3289 8.2216 6.17568C8.02854 6.02247 7.91824 5.82709 7.69763 5.43633L7.26753 4.6745Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39925 6.66663L7.01704 12.6198C6.71728 13.9109 6.5674 14.5564 6.73864 15.1634C6.74199 15.1752 6.74541 15.187 6.74893 15.1988C6.92928 15.8031 7.40036 16.2643 8.3425 17.1865C9.11975 17.9473 9.50842 18.3277 9.98625 18.3332C9.99534 18.3333 10.0043 18.3333 10.0134 18.3332C10.4913 18.3277 10.8799 17.9473 11.6572 17.1865C12.5993 16.2643 13.0704 15.8031 13.2508 15.1988C13.2543 15.187 13.2577 15.1752 13.261 15.1634C13.4323 14.5564 13.2824 13.9109 12.9827 12.6198L11.6004 6.66663",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignation);
export default __webpack_public_path__ + "static/media/designation.58a3f4bae13cd200131a2e8f1de97bca.svg";
export { ForwardRef as ReactComponent };